/* LittleMaddy bundle picker, per-bra colour/size rows and free guide.
   Delegated, so it keeps working after Dawn re-renders the buy box on variant change. */
(function () {
  if (window.__lmBundle) return; window.__lmBundle = 1;
  var rowsState = []; // [{c:'Black', s:'M'}] for bra 2, 3
  function box() { return document.querySelector('[data-lm-bundle]'); }
  var PD = null;
  function data() { return PD; }
  function loadData() {
    var pi = document.querySelector('product-info[data-url]');
    var url = (pi && pi.getAttribute('data-url')) || location.pathname.replace(/\/$/, '');
    if (url.indexOf('/products/') < 0) return;
    fetch(url.split('?')[0] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      PD = { o: p.options.map(function (o) { return { n: o.name, v: o.values }; }), v: p.variants.map(function (x) { return { id: x.id, o: x.options, a: x.available }; }) };
      renderRows();
    }).catch(function () {});
  }
  function ensurePicks() {
    var b = box(); if (!b) return null;
    var p = document.querySelector('[data-lm-picks]');
    if (p) return p;
    p = document.createElement('div'); p.className = 'lm-picks'; p.setAttribute('data-lm-picks', ''); p.hidden = true;
    p.innerHTML = '<p class="lm-picks__lead">Pick a colour and size for each bra</p><div class="lm-pick lm-pick--main"><span class="lm-pick__n">Bra 1</span><span class="lm-pick__main" data-lm-main-label></span><span class="lm-pick__note">chosen above</span></div><div data-lm-rows></div>';
    b.parentNode.insertBefore(p, b.nextSibling);
    return p;
  }
  function checkedQty(b) { var c = b && b.querySelector('input[type=radio]:checked'); return c ? parseInt(c.value, 10) : 1; }
  function mainForm() { var b = box(); var sid = b && b.getAttribute('data-section'); return document.getElementById('product-form-' + sid) || document.querySelector('product-form form'); }
  function mainVariantId() { var f = mainForm(); var i = f && f.querySelector('input[name="id"]'); return i ? parseInt(i.value, 10) : 0; }
  function findVariant(d, opts) { for (var i = 0; i < d.v.length; i++) { var x = d.v[i], ok = true; for (var k = 0; k < opts.length; k++) if (x.o[k] !== opts[k]) ok = false; if (ok) return x; } return null; }
  function byId(d, id) { for (var i = 0; i < d.v.length; i++) if (d.v[i].id === id) return d.v[i]; return null; }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var bumpState = { on: false, v: null };
  function bumpBox() { return document.querySelector('[data-lm-bump]'); }
  function bumpVid() { var b = bumpBox(); if (!b) return 0; var c = b.querySelector('input[type=checkbox]'); if (!c || !c.checked) return 0; var v = b.querySelector('[data-lm-bump-variant]'); return v ? parseInt(v.value, 10) : 0; }
  function restoreBump() {
    var b = bumpBox(); if (!b) return;
    var c = b.querySelector('input[type=checkbox]'), v = b.querySelector('select[data-lm-bump-variant]');
    if (c && c.checked !== bumpState.on) c.checked = bumpState.on;
    if (v && bumpState.v && v.value !== bumpState.v) v.value = bumpState.v;
  }
  function restore() {
    var b = box(); if (!b || !window.lmQty) return;
    var r = b.querySelector('input[value="' + window.lmQty + '"]');
    if (r && !r.checked) r.checked = true;
  }
  function renderRows() {
    var d = data(); if (!d) return; var p = ensurePicks(); if (!p) return;
    var n = window.lmQty || 1;
    if (p.hidden !== (n < 2)) p.hidden = n < 2;
    var mv = byId(d, mainVariantId());
    var lab = p.querySelector('[data-lm-main-label]'); if (lab && mv && lab.textContent !== mv.o.join(' · ')) lab.textContent = mv.o.join(' · ');
    var host = p.querySelector('[data-lm-rows]'); if (!host) return;
    while (rowsState.length < n - 1) rowsState.push(mv ? mv.o.slice() : d.o.map(function (o) { return o.v[0]; }));
    var want = Math.max(0, n - 1);
    if (host.getAttribute('data-n') === String(want) && host.children.length === want) return;
    var h = '';
    for (var r = 0; r < want; r++) {
      h += '<div class="lm-pick"><span class="lm-pick__n">Bra ' + (r + 2) + '</span><span class="lm-pick__sel">';
      d.o.forEach(function (o, k) {
        h += '<label class="visually-hidden" for="lm-pick-' + r + '-' + k + '">Bra ' + (r + 2) + ' ' + esc(o.n) + '</label>';
        h += '<select id="lm-pick-' + r + '-' + k + '" data-row="' + r + '" data-opt="' + k + '">';
        o.v.forEach(function (val) { h += '<option value="' + esc(val) + '"' + (rowsState[r][k] === val ? ' selected' : '') + '>' + esc(val) + '</option>'; });
        h += '</select>';
      });
      h += '</span></div>';
    }
    host.innerHTML = h; host.setAttribute('data-n', String(want));
  }
  function apply(fromUser) {
    var b = box(); if (!b) return;
    if (fromUser || !window.lmQty) window.lmQty = checkedQty(b); else restore();
    var sid = b.getAttribute('data-section');
    var q = document.getElementById('Quantity-' + sid) || document.querySelector('input[name="quantity"]');
    if (q) q.value = window.lmQty;
    renderRows();
    restoreBump();
  }
  function showError(msg) {
    var b = box(); var sid = b && b.getAttribute('data-section');
    var w = document.getElementById('Product-form-error-message-wrapper-' + sid) || document.querySelector('.product-form__error-message-wrapper');
    if (!w) { console.warn(msg); return; }
    var m = w.querySelector('.product-form__error-message'); if (m) m.textContent = msg; w.hidden = false;
  }
  function addSet(btn) {
    var d = data(), b = box(); if (!d || !b) return false;
    var main = mainVariantId(); if (!main) return false;
    var counts = {}; counts[main] = 1;
    for (var r = 0; r < (window.lmQty || 1) - 1; r++) {
      var v = findVariant(d, rowsState[r]);
      if (!v || !v.a) { showError('Bra ' + (r + 2) + ': ' + rowsState[r].join(' · ') + ' is sold out. Please pick another size or colour.'); return true; }
      counts[v.id] = (counts[v.id] || 0) + 1;
    }
    var bv = bumpVid(); if (bv) counts[bv] = (counts[bv] || 0) + 1;
    var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
    var guide = parseInt(b.getAttribute('data-guide') || '0', 10);
    var drawer = document.querySelector('cart-drawer');
    btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading');
    var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.remove('hidden');
    function done() { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); if (sp) sp.classList.add('hidden'); }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (guide && !cart.items.some(function (i) { return i.variant_id === guide; })) items.push({ id: guide, quantity: 1 });
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    }).then(function (r) { return r.json(); }).then(function (res) {
      done();
      if (res.status) { showError(res.description || res.message || 'Something went wrong. Please try again.'); return; }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lm-set', cartData: res });
      if (drawer && res.sections && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
      else window.location.href = '/cart';
    }).catch(function () { done(); showError('Something went wrong. Please try again.'); });
    return true;
  }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.closest('[data-lm-bump]')) { var bb = bumpBox(); var cc = bb.querySelector('input[type=checkbox]'), vv = bb.querySelector('select[data-lm-bump-variant]'); bumpState.on = !!(cc && cc.checked); if (vv) bumpState.v = vv.value; return; }
    if (t.matches('[data-lm-picks] select')) { var r = +t.getAttribute('data-row'), k = +t.getAttribute('data-opt'); if (rowsState[r]) rowsState[r][k] = t.value; return; }
    if (t.closest('[data-lm-bundle]')) apply(true);
  });
  document.addEventListener('submit', function (e) { if (e.target.closest && e.target.closest('product-form')) apply(false); }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-form__submit'); if (!btn || !box()) return;
    apply(false);
    if (((window.lmQty || 1) > 1 || bumpVid()) && btn.getAttribute('aria-disabled') !== 'true') {
      if (addSet(btn)) { e.preventDefault(); e.stopImmediatePropagation(); }
    }
  }, true);
  document.addEventListener('lm:pick', function (e) {
    var b = box(); if (!b) return;
    var r = b.querySelector('input[value="' + e.detail.qty + '"]'); if (r) { r.checked = true; apply(true); }
  });
  var mt; new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(function () { apply(false); }, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  var busy = false;
  function ensureGuide() {
    var b = box(); if (!b || busy) return;
    var guide = parseInt(b.getAttribute('data-guide') || '0', 10), prod = parseInt(b.getAttribute('data-product') || '0', 10);
    if (!guide) return;
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var hasBra = cart.items.some(function (i) { return i.product_id === prod; });
      var hasGuide = cart.items.some(function (i) { return i.variant_id === guide; });
      if (!hasBra || hasGuide) { busy = false; return; }
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: guide, quantity: 1 }] };
      if (drawer && drawer.getSectionsToRender) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) { if (drawer && res.sections && drawer.renderContents) drawer.renderContents(res); busy = false; });
    }).catch(function () { busy = false; });
  }
  function hook() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.source === 'product-form') setTimeout(ensureGuide, 150); });
      return true;
    }
    return false;
  }
  function start() { loadData(); apply(true); if (!hook()) { var n = 0, iv = setInterval(function () { if (hook() || ++n > 40) clearInterval(iv); }, 250); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
